import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_KEY}>{element}</GoogleReCaptchaProvider>
);

export const onRouteUpdate = ({ location }) => scrollToAnchor(location);

function scrollToAnchor(location) {
  window.requestAnimationFrame(() => {
    if (location && location.hash) {
      // Get anchor element we are trying to show.
      let scrollTarget = location.hash.replace('#', '');

      // Because of how the header component id property is used we're having to use the text of the header we want to scroll to!
      // So decode the header id e.g. 'Course%20fee' becomes 'Course fee'
      scrollTarget = decodeURIComponent(scrollTarget);

      const element = document.getElementById(scrollTarget);

      if (element === null) return;

      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  window.history.scrollRestoration = 'manual';
  const [savedScrollPositionLeft, savedScrollPositionTop] = getSavedScrollPosition(location) || [0, 0];

  if (location && location.hash) {
    scrollToAnchor(location);
    return;
  }

  setTimeout(() => {
    window.scrollTo({
      top: savedScrollPositionTop,
      left: savedScrollPositionLeft,
      behavior: 'instant',
    });
  }, 600);

  return false;
};
